
<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';

import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import $ from 'jquery';

export default {
  components: { ErrorMessage, Layout, PageHeader , ModelSelect },
  data() {
    return {
      title: "Flight Sales Report",
      items: [
        {
          text: "Report",
          href: "/",
        },
        {
          text: "Flight Sales Report",
          active: true,
        },
      ],
        admins:[],
        alladmins:[],
      errors: null,
        display_div:true,
        user_type:"",
      sales: [],
      user_id: "",
      startdate: "",
      enddate: "",
        visible:false,
        message:"",
        airline_pnr:"",
        ticket_no:""
    };
  },
  mounted() {
    this.getAdminList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      toggleDiv: function() {
          this.display_div = !this.display_div;
      },
      async getAdminList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c'){
                                  if(temp[i].first_name==null){
                                      temp[i].text=temp[i].email + '(unregistered)';
                                  }else{
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  }
                                  temp[i].value = temp[i].id;
                                  arr.push(temp[i]);
                              }

                          }
                          this.alladmins=arr;
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      onChange(event) {
          this.user_type=event.target.value;
          var temp=this.alladmins;
          var arr=[];
          var i;
          for (i=0;i<temp.length;i++){
              if (temp[i].account_type==event.target.value){
                  arr.push(temp[i]);
              }
          }
          this.admins = arr;
      },
    async search() {
      try {
        axios
          .get("/api/reports/flightSales", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              startdate: this.startdate,
              enddate: this.enddate,
                airline_pnr:this.airline_pnr,
                ticket_no:this.ticket_no,
                user_id:this.user_id
            },
          })
          .then((response) => {
            if (response.data.status) {
              let indexedSales = response.data.data.ticket;
              let index=1;
              for(let i in indexedSales){
                   indexedSales[i].new_index=index;
                  index++;
              }
              this.sales=indexedSales;
                setTimeout(function(){

                        $('#example').DataTable(
                            {
                                pagingType: 'full_numbers',
                                pageLength: 5,
                                processing: true,
                                dom: 'Bfrtip',
                                bDestroy: true,
                                bSort : false,
                                paging:false,
                                buttons: [
                                    {
                                        extend: 'copyHtml5',
                                        exportOptions: {
                                            columns: [1, 2, 3, 4, 5, 6, 7]
                                        }
                                    },
                                    'csv',
                                    {
                                        extend: 'pdfHtml5',
                                        exportOptions: {
                                            columns: [1, 2, 3, 4, 5, 6, 7]
                                        }
                                    },
                                    {
                                        extend: 'print',
                                        footer: 'true',
                                        title: "Flight Sales Report",
                                        autoPrint: 'false',
                                        customize: function (win) {
                                            $(win.document.body)
                                                .css('font-size', '6pt');

                                            $(win.document.body).find('table')
                                                .addClass('compact')
                                                .css('font-size', 'inherit');
                                        }
                                    }
                                ],
                            }
                        );
                    },
                    10
                );
                $("#example").DataTable().clear().destroy();
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      clear() {
          this.user_type="";
          this.user_id="";
          this.startdate="";
          this.enddate="";
          this.airline_pnr="";
          this.ticket_no="";
      },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.$swal("Error", obj.message, "error");
        this.search();
      } else if (obj.message == "Token has expired") {
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
              <h4 class="card-title">Flight Sales Report</h4>
            <div v-if="display_div" class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="user_type">Select User Type</label>
                        <select
                            id="user_type"
                            name="user_type"
                            v-model="user_type"
                            class="form-control"
                            @change="onChange($event)"
                            placeholder="Select User Type">
                            <option value="b2b">B2B
                            </option>
                            <option value="b2c">B2C
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Select User</label>
                        <model-select :options="admins"
                                      v-model="user_id"
                                      placeholder="Select User">
                        </model-select>
                    </div>
                </div>
              <div class="col-md-6">
                <div>
                  <label for="start-datepicker">Booking From Date</label>
                  <b-form-datepicker id="start-datepicker" v-model="startdate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
              <div class="col-md-6">
                <div>
                  <label for="end-datepicker">Booking To Date</label>
                  <b-form-datepicker id="end-datepicker" v-model="enddate" class="mb-2"></b-form-datepicker>
                </div>
              </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="airline_pnr">Airline Pnr</label>
                        <input
                            id="airline_pnr"
                            v-model="airline_pnr"
                            name="airline_pnr"
                            type="text"
                            class="form-control"
                            placeholder="Type Airline Pnr"
                        />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="ticket_no">Ticket No</label>
                        <input
                            id="ticket_no"
                            v-model="ticket_no"
                            name="ticket_no"
                            type="text"
                            class="form-control"
                            placeholder="Type Ticket No."
                        />
                    </div>
                </div>
                <div class="col-md-12 text-center"><span><button class="btn btn-primary" @click.prevent="search()">Search</button></span><span><button class="btn btn-light" @click.prevent="clear()">Clear</button></span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table id="example" class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>#</th>
                      <th>Ticket Issue Date</th>
                    <th>Ticket No</th>
                      <th>User</th>
                    <th>Pax Name</th>
<!--                    <th>First Name</th>-->
<!--                    <th>Last Name</th>-->
                    <th>Passport</th>
                    <th>Status</th>
                    <th>Ref. Key</th>
                    <th>Type</th>
                    <th>API PNR</th>
                    <th>Airline PNR</th>
                    <th>Base Fare</th>
                      <th>Tax</th>
                    <th>Gross Fare</th>
                      <th>Commission</th>
                      <th>Markup</th>
                      <th>Ait</th>
                    <th>Invoice Fare</th>
                    <th>User Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(sale,index) in sales" v-bind:key="index">
                    <th scope="row">{{sale.new_index}}</th>
                      <td>{{sale.ticket.created_at | moment('ll')}}</td>
                    <td>{{sale.ticket.ticket_no}}</td>
                      <td v-if="sale.booking.account_type=='b2b'">{{sale.booking.agency_name+"("+sale.booking.account_type+")"}} <router-link  :to="{ name: 'admin_agent_details', params: {id: sale.booking.user.id } }" target="_blank" >{{sale.booking.user.username==null ? 'N/A' : sale.booking.user.username}}</router-link></td>
                      <td v-if="sale.booking.account_type=='b2c'">{{sale.booking.user.first_name+' '+sale.booking.user.last_name+"("+sale.booking.account_type+")"}} <router-link  :to="{ name: 'admin_agent_details', params: {id: sale.booking.user.id } }" target="_blank" >{{sale.booking.user.username==null ? 'N/A' : sale.booking.user.username}}</router-link></td>
                    <td>{{sale.passenger.prefix+' '+sale.passenger.first_name+' '+sale.passenger.last_name}}</td>
                    <td>{{sale.passenger.passport_no}}</td>
                    <td>{{sale.booking.booking_status.status_name}}</td>
                    <td>{{sale.booking.search_reference_key}}</td>
                      <td>{{sale.booking.trip_type=='R'?"Round Trip":"One Way"}}</td>
                      <td>{{sale.booking.api_pnr==null?'N/A':sale.booking.api_pnr}}</td>
                      <td>{{sale.booking.airline_pnr==null?'N/A':sale.booking.airline_pnr}}</td>
                    <td>{{sale.passenger.base_fare==null?'N/A':sale.passenger.base_fare}}</td>
                      <td>{{sale.passenger.total_tax==null?'N/A':sale.passenger.total_tax}}</td>
                    <td>{{sale.passenger.gross_fare==null?'N/A':sale.passenger.gross_fare}}</td>
                      <td>{{sale.passenger.commission==null?'N/A':sale.passenger.commission}}</td>
                      <td>{{sale.passenger.markup==null?'N/A':sale.passenger.markup}}</td>
                      <td>{{sale.passenger.ait==null?'N/A':sale.passenger.ait}}</td>
                    <td>{{sale.booking.invoice_fare==null?'N/A':sale.booking.invoice_fare}}</td>
                    <td>{{sale.ticket.available_balance==null?'N/A':sale.ticket.available_balance}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.dataTables_wrapper .dataTables_info, .dataTables_wrapper .dataTables_paginate {

    display: none;
}
table.dataTable thead th {
    border-bottom: none;
}
table.dataTable.no-footer {
    border-bottom: none;
}
table.dataTable thead th, table.dataTable thead td {
     padding: 10px 10px;
}
td.dataTables_empty {
    display: none;
}
</style>
